export const defaultEnvironment = {
  production: false,
  //loginURL: 'https://mycableengineering.com/authentication/signin',
  mceLogURL: 'https://mycableengineering.com/Portals/0/Images/logo/license/myCableEngineeringLogo_300x75.png',

  firebase: {
    apiKey: "AIzaSyBfLbiBfAEQTyQU-jNwjKJzSbLQaTuflfA",
    authDomain: "mce-app-lotppu.firebaseapp.com",
    projectId: "mce-app-lotppu",
    storageBucket: "mce-app-lotppu.appspot.com",
    messagingSenderId: "1067440674509",
    appId: "1:1067440674509:web:f6b1edb82247fa23957b84",
    measurementId: "G-PC21THXHKQ"
  },

  reCaptchaV3Key: "6Lcu3gEqAAAAANu8u9ULJJ5pGPBBw0d2Bfu_yW9_",

  mceApiUrl: "https://localhost:44306",

};
